import { useEffect, useRef } from "react";

export function useStoreDialog(ref, open, onClose) {
  const close = useRef(onClose);
  useEffect(() => { close.current = onClose; }, [onClose]);
  useEffect(() => {
    if (!open || !ref.current) return;
    const dialog = ref.current;
    const previous = document.activeElement;
    const beforeOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const controls = () => [...dialog.querySelectorAll('button, input, select, textarea, summary, a[href], [tabindex="0"]')].filter(el => !el.matches(":disabled") && !el.hidden && el.getAttribute("type") !== "hidden" && (!el.closest("details:not([open])") || el.tagName === "SUMMARY"));
    (controls()[0] || dialog).focus();
    const keydown = event => {
      const dialogs = [...document.querySelectorAll('[role="dialog"]')];
      if (dialogs[dialogs.length - 1] !== dialog) return;
      if (event.key === "Escape") { event.stopPropagation(); close.current?.(); }
      if (event.key === "Tab") {
        const items = controls(), first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener("keydown",keydown);
    return () => { document.body.style.overflow = beforeOverflow; document.removeEventListener("keydown",keydown); if(previous?.isConnected) previous.focus(); };
  }, [ref,open]);
}
